import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function useUrlView(key, allowed, fallback) {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const requested = params.get(key);
  const resolved = allowed.includes(requested) ? requested : fallback;
  const [value, setView] = useState(resolved);
  useEffect(() => setView(resolved), [resolved, location.search, key]);
  function setValue(next, changes = {}) {
    if (!allowed.includes(next)) return;
    setView(next);
    const nextParams = new URLSearchParams(location.search);
    nextParams.set(key, next);
    Object.entries(changes).forEach(([name, entry]) => entry == null ? nextParams.delete(name) : nextParams.set(name, String(entry)));
    const search = `?${nextParams.toString()}`;
    if (search !== location.search) navigate({ pathname: location.pathname, search, hash: location.hash });
  }
  return [value, setValue];
}
